const seinfeldCast = new URL(
  "../assets/images/seinfeld-cast.jpg",
  import.meta.url,
).href;
const seinfeldHome =
  "https://cdn.britannica.com/09/189409-050-01172C19/Cast-Jason-Alexander-Seinfeld-Michael-Richards.jpg";
const theOfficeCast = new URL(
  "../assets/images/the-office-cast.jpg",
  import.meta.url,
).href;
const theOfficeHome =
  "https://ntvb.tmsimg.com/assets/p7893514_b_h8_ab.jpg?w=960&h=540";
const arrestedDevelopmentHome =
  "https://i0.wp.com/comicsonline.com/wp-content/uploads/header-arrested-development-season-4-first-full-trailer.jpg?resize=750%2C398";
const alwaysSunnyHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/583/1459030.jpg";
const alwaysSunnyHome =
  "https://decider.com/wp-content/uploads/2019/05/25-best-shows-in-fx-history-always-sunny-winner.jpg?quality=75&strip=all&w=978&h=652&crop=1";
const parksAndRecHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/481/1204341.jpg";
const parksAndRecHome =
  "https://mediaproxy.tvtropes.org/width/1200/https://static.tvtropes.org/pmwiki/pub/images/img_5022_0.jpeg";
const brooklynNineNineHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/402/1007484.jpg";
const arrestedDevelopmentHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/338/846049.jpg";
// High Maintenance
const highMaintenanceHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/178/445619.jpg";
const highMaintenanceHome =
  "https://static.tvmaze.com/uploads/images/original_untouched/223/557940.jpg";
// Broad City
const broadCityHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/405/1012900.jpg";
const broadCityHome =
  "https://static.tvmaze.com/uploads/images/original_untouched/223/559631.jpg";
const friendsHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/442/1106977.jpg";
const friendsHome =
  "https://static.tvmaze.com/uploads/images/original_untouched/219/548045.jpg";
const modernFamilyHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/359/898320.jpg";
const modernFamilyHome =
  "https://static.tvmaze.com/uploads/images/original_untouched/17/42844.jpg";
const gameOfThronesHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/498/1245274.jpg";
const gameOfThronesHome =
  "https://static.tvmaze.com/uploads/images/original_untouched/389/973562.jpg";
const theSopranosHero =
  "https://static.tvmaze.com/uploads/images/original_untouched/4/11341.jpg";
const theSopranosHome =
  "https://static.tvmaze.com/uploads/images/original_untouched/223/558679.jpg";

export const heroAssetRegistry = {
  "seinfeld-home": {
    src: seinfeldHome,
    alt: "Seinfeld cast landscape image with Jerry Seinfeld, Jason Alexander, Michael Richards, and Julia Louis-Dreyfus.",
    objectPosition: "center 30%",
    credit: {
      title: "Seinfeld cast landscape image",
      creator: "Britannica",
      source: "https://www.britannica.com/topic/Seinfeld-TV-series",
      license: "Used for app home page display",
      licenseUrl: "https://cdn.britannica.com/09/189409-050-01172C19/Cast-Jason-Alexander-Seinfeld-Michael-Richards.jpg",
      notes: "Landscape image used for home page card.",
    },
  },
  "seinfeld-cast.jpg": {
    src: seinfeldCast,
    alt: "Seinfeld promotional key art with Kramer, George Costanza, Elaine Benes, and Jerry Seinfeld.",
    objectPosition: "center 62%",
    credit: {
      title: "Seinfeld promotional key art",
      creator: "Source provided by user",
      source:
        "https://m.media-amazon.com/images/M/MV5BMmRjNjZjN2ItN2FkYi00ZDg0LWExN2EtMTU2ODUwNWU1M2NhXkEyXkFqcGc@._V1_.jpg",
      license: "User-supplied source",
      licenseUrl:
        "https://m.media-amazon.com/images/M/MV5BMmRjNjZjN2ItN2FkYi00ZDg0LWExN2EtMTU2ODUwNWU1M2NhXkEyXkFqcGc@._V1_.jpg",
      notes:
        "Bundled locally from the image URL supplied for this app refresh.",
    },
  },
  "the-office-home": {
    src: theOfficeHome,
    alt: "The Office cast landscape image.",
    objectPosition: "center 30%",
    credit: {
      title: "The Office landscape image",
      creator: "TMS",
      source: "https://ntvb.tmsimg.com/assets/p7893514_b_h8_ab.jpg",
      license: "Used for app home page display",
      licenseUrl: "https://ntvb.tmsimg.com/assets/p7893514_b_h8_ab.jpg?w=960&h=540",
      notes: "Landscape image used for home page card.",
    },
  },
  "the-office-cast.jpg": {
    src: theOfficeCast,
    alt: "The Office promotional cast image with Michael Scott, Dwight Schrute, Pam Beesly, Ryan Howard, and Jim Halpert.",
    objectPosition: "center 14%",
    credit: {
      title: "The Office promotional key art",
      creator: "Source provided by user",
      source:
        "https://m.media-amazon.com/images/M/MV5BZjQwYzBlYzUtZjhhOS00ZDQ0LWE0NzAtYTk4MjgzZTNkZWEzXkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg",
      license: "User-supplied source",
      licenseUrl:
        "https://m.media-amazon.com/images/M/MV5BZjQwYzBlYzUtZjhhOS00ZDQ0LWE0NzAtYTk4MjgzZTNkZWEzXkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg",
      notes:
        "Bundled locally from the image URL supplied for this app refresh.",
    },
  },
  "its-always-sunny-hero": {
    src: alwaysSunnyHero,
    alt: "It's Always Sunny in Philadelphia cast promo image with Charlie, Dennis, Mac, Dee, and Frank.",
    objectPosition: "center 28%",
    credit: {
      title: "It's Always Sunny in Philadelphia promotional image",
      creator: "TVMaze",
      source:
        "https://www.tvmaze.com/shows/347/its-always-sunny-in-philadelphia",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/583/1459030.jpg",
      notes: "Loaded from TVMaze show artwork for the app hero card.",
    },
  },
  "its-always-sunny-home": {
    src: alwaysSunnyHome,
    alt: "It's Always Sunny in Philadelphia cast ensemble landscape image.",
    objectPosition: "center 40%",
    credit: {
      title: "It's Always Sunny in Philadelphia landscape image",
      creator: "Decider",
      source: "https://decider.com/article/25-best-shows-in-fx-history/",
      license: "Used for app home page display",
      licenseUrl:
        "https://decider.com/wp-content/uploads/2019/05/25-best-shows-in-fx-history-always-sunny-winner.jpg",
      notes: "Landscape image used for home page card display.",
    },
  },
  "parks-and-rec-home": {
    src: parksAndRecHome,
    alt: "Parks and Recreation ensemble landscape image with the full Pawnee team.",
    objectPosition: "center top",
    credit: {
      title: "Parks and Recreation landscape image",
      creator: "TV Tropes",
      source:
        "https://tvtropes.org/pmwiki/pmwiki.php/Series/ParksAndRecreation",
      license: "Used for app home page display",
      licenseUrl:
        "https://static.tvtropes.org/pmwiki/pub/images/img_5022_0.jpeg",
      notes: "Landscape image used for home page card display.",
    },
  },
  "parks-and-rec-hero": {
    src: parksAndRecHero,
    alt: "Parks and Recreation ensemble key art with Leslie Knope, Ron Swanson, April Ludgate, and the Pawnee team.",
    objectPosition: "center 35%",
    credit: {
      title: "Parks and Recreation promotional image",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/174/parks-and-recreation",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/481/1204341.jpg",
      notes: "Loaded from TVMaze show artwork for the app hero card.",
    },
  },
  "brooklyn-nine-nine-hero": {
    src: brooklynNineNineHero,
    alt: "Brooklyn Nine-Nine cast image with Jake Peralta, Amy Santiago, Rosa Diaz, Terry Jeffords, and Captain Holt.",
    objectPosition: "center 18%",
    credit: {
      title: "Brooklyn Nine-Nine promotional image",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/49/brooklyn-nine-nine",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/402/1007484.jpg",
      notes: "Loaded from TVMaze show artwork for the app hero card.",
    },
  },
  "arrested-development-home": {
    src: arrestedDevelopmentHome,
    alt: "Arrested Development cast landscape image with the Bluth family.",
    objectPosition: "center 30%",
    credit: {
      title: "Arrested Development landscape image",
      creator: "Comics Online",
      source: "https://comicsonline.com/",
      license: "Used for app home page display",
      licenseUrl: "https://i0.wp.com/comicsonline.com/wp-content/uploads/header-arrested-development-season-4-first-full-trailer.jpg",
      notes: "Landscape image used for home page card.",
    },
  },
  "arrested-development-hero": {
    src: arrestedDevelopmentHero,
    alt: "Arrested Development ensemble promo with the Bluth family cast.",
    objectPosition: "center 24%",
    credit: {
      title: "Arrested Development promotional image",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/321/arrested-development",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/338/846049.jpg",
      notes: "Loaded from TVMaze show artwork for the app hero card.",
    },
  },
  "high-maintenance-hero": {
    src: highMaintenanceHero,
    alt: "High Maintenance portrait poster with Ben Sinclair as The Guy.",
    objectPosition: "center 20%",
    credit: {
      title: "High Maintenance promotional poster",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/20913/high-maintenance",
      license: "Remote image used for app display",
      licenseUrl: "https://static.tvmaze.com/uploads/images/original_untouched/178/445619.jpg",
      notes: "Loaded from TVMaze show artwork.",
    },
  },
  "high-maintenance-home": {
    src: highMaintenanceHome,
    alt: "High Maintenance landscape background image.",
    objectPosition: "center 40%",
    credit: {
      title: "High Maintenance background image",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/20913/high-maintenance",
      license: "Remote image used for app display",
      licenseUrl: "https://static.tvmaze.com/uploads/images/original_untouched/223/557940.jpg",
      notes: "Landscape background used for home page card.",
    },
  },
  "broad-city-hero": {
    src: broadCityHero,
    alt: "Broad City portrait poster with Abbi Jacobson and Ilana Glazer.",
    objectPosition: "center 20%",
    credit: {
      title: "Broad City promotional poster",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/375/broad-city",
      license: "Remote image used for app display",
      licenseUrl: "https://static.tvmaze.com/uploads/images/original_untouched/405/1012900.jpg",
      notes: "Loaded from TVMaze show artwork.",
    },
  },
  "broad-city-home": {
    src: broadCityHome,
    alt: "Broad City landscape background image.",
    objectPosition: "center 40%",
    credit: {
      title: "Broad City background image",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/375/broad-city",
      license: "Remote image used for app display",
      licenseUrl: "https://static.tvmaze.com/uploads/images/original_untouched/223/559631.jpg",
      notes: "Landscape background used for home page card.",
    },
  },
  "friends-hero": {
    src: friendsHero,
    alt: "Friends portrait ensemble poster with Rachel, Monica, Phoebe, Joey, Chandler, and Ross.",
    objectPosition: "center 28%",
    credit: {
      title: "Friends promotional poster",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/431/friends",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/442/1106977.jpg",
      notes: "High-resolution portrait artwork loaded from the TVMaze image gallery.",
    },
  },
  "friends-home": {
    src: friendsHome,
    alt: "Friends landscape cast image with the six main characters together.",
    objectPosition: "center 40%",
    credit: {
      title: "Friends landscape background image",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/431/friends",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/219/548045.jpg",
      notes: "High-resolution landscape artwork loaded from the TVMaze image gallery.",
    },
  },
  "game-of-thrones-hero": {
    src: gameOfThronesHero,
    alt: "Game of Thrones portrait poster featuring key characters from the major houses of Westeros.",
    objectPosition: "center 28%",
    credit: {
      title: "Game of Thrones promotional poster",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/82/game-of-thrones",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/498/1245274.jpg",
      notes: "Portrait hero artwork loaded from TVMaze's image gallery.",
    },
  },
  "game-of-thrones-home": {
    src: gameOfThronesHome,
    alt: "Game of Thrones landscape banner artwork with an icy blue fantasy backdrop.",
    objectPosition: "center 42%",
    credit: {
      title: "Game of Thrones landscape background",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/82/game-of-thrones",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/389/973562.jpg",
      notes: "Landscape artwork loaded from TVMaze's image gallery.",
    },
  },
  "the-sopranos-hero": {
    src: theSopranosHero,
    alt: "The Sopranos portrait poster featuring Tony Soprano and the core New Jersey crew.",
    objectPosition: "center 20%",
    credit: {
      title: "The Sopranos promotional poster",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/527/the-sopranos",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11341.jpg",
      notes: "Portrait hero artwork loaded from TVMaze's image gallery.",
    },
  },
  "the-sopranos-home": {
    src: theSopranosHome,
    alt: "The Sopranos landscape background image used on show cards.",
    objectPosition: "center 38%",
    credit: {
      title: "The Sopranos landscape background",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/527/the-sopranos",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/223/558679.jpg",
      notes: "Landscape artwork loaded from TVMaze's image gallery.",
    },
  },
  "modern-family-hero": {
    src: modernFamilyHero,
    alt: "Modern Family cast portrait featuring the Pritchett-Dunphy-Tucker family.",
    objectPosition: "center 25%",
    credit: {
      title: "Modern Family promotional poster",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/80/modern-family",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/359/898320.jpg",
      notes: "Main poster image loaded from TVMaze's show image gallery.",
    },
  },
  "modern-family-home": {
    src: modernFamilyHome,
    alt: "Modern Family cast landscape background image.",
    objectPosition: "center 38%",
    scale: 1.15,
    credit: {
      title: "Modern Family landscape image",
      creator: "TVMaze",
      source: "https://www.tvmaze.com/shows/80/modern-family",
      license: "Remote image used for app display",
      licenseUrl:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/42844.jpg",
      notes: "Landscape background loaded from TVMaze's image gallery.",
    },
  },
};
